/**
 * Eine anklickbare Verknuepfung - "Ziel: Marathon", "Projekt: Umzug".
 *
 * Leitlinie 5: Verknuepfungen sind ueberall sichtbar UND anklickbar. Optional
 * mit einem x zum Loesen, dort wo man die Verknuepfung auch aendern kann.
 */
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils/cn';

export function LinkChip({
  to, icon: Icon, label, art, onRemove, className,
}: {
  to: string;
  icon: LucideIcon;
  label: string;
  /** Was verlinkt ist - fuer Tooltip und Screenreader, z. B. "Ziel". */
  art: string;
  onRemove?: () => void;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex max-w-full shrink-0 items-center rounded-full bg-surface-raised text-[11px] text-ink-muted',
        className,
      )}
    >
      <Link
        to={to}
        title={`${art}: ${label}`}
        aria-label={`${art}: ${label}`}
        onPointerDown={(e) => e.stopPropagation()}
        className="inline-flex min-w-0 items-center gap-1 rounded-full py-0.5 pl-2 pr-2 transition-colors hover:text-ink"
      >
        <Icon className="size-3 shrink-0" />
        <span className="max-w-40 truncate">{label}</span>
      </Link>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          onPointerDown={(e) => e.stopPropagation()}
          title={`${art} lösen`}
          aria-label={`${art} „${label}" lösen`}
          className="-ml-1 grid size-5 place-items-center rounded-full text-ink-faint transition-colors hover:text-ink"
        >
          <X className="size-3" />
        </button>
      )}
    </span>
  );
}
